import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { LoadingFullScreen } from '/imports/ui/LoadingFullScreen';
import { makeNewUtilityAccountLink } from '/imports/api/utilityAccounts';

const UtilityAccountIntakeLinkStyled = styled.div`
`;

/**
 * Mints a fresh utility-account intake link for the org/hid in the URL, then redirects to it.
 */
export const UtilityAccountIntakeLink = () => {
  const params = new URLSearchParams(location.search);
  const orgId = params.get('o');
  const hid = params.get('hid') || undefined;
  const navigate = useNavigate();
  useEffect(() => {
    if (!orgId) return;
    (async () => {
      const link = await makeNewUtilityAccountLink.call({ orgId, hid });
      navigate(link.replace(`https://${window.location.host}`, ''), { replace: true });
    })();
  }, []);
  return (
    <UtilityAccountIntakeLinkStyled className="page">
      <LoadingFullScreen />
    </UtilityAccountIntakeLinkStyled>
  );
};